// components/Blocks/BirthCertificateBlock.js
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import certificate_img from '../../../../../../../img/documents.svg';
import FileUploader from '../../../../../../../components/FileUpload/FileUploader';
import { localDateString  } from '../../../../../../../components/helpers/datetranslate';

const BirthCertificateBlock = ({ 
  data, 
  onChange, 
  editable, 
  defaultOpen = false, 
  isViewOnly = false,
  onFileViewRequest,
  onFileDownload
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const handleFieldChange = (field, value) => {
    if (isViewOnly) return;
    onChange(field, value);
  };

  const handleFilesChange = (files) => {
    if (isViewOnly) return;
    
    // Добавляем информацию о секции к каждому файлу
    const filesWithSection = files.map(file => ({
      ...file,
      section: 'certificate'
    }));
    
    onChange('birthCertificateFiles', filesWithSection);
  };

  const handleFileView = (file) => {
    onChange('birthCertificateFileView', file);
  };


  return (
    <div className="card-block">
      <button
        className="block-header"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="left">
          <img className="blk-icon" src={certificate_img} alt="" />
          <span className="title">Свідоцтво про народження</span>
          {!isOpen && (
            <span className="subtitle">
              {data.birthCertificateNumber} {data.birthCertificateDate && `• видане ${localDateString(data.birthCertificateDate)}`}
            </span>
          )}
        </div>
        <FontAwesomeIcon 
          icon={isOpen ? faChevronUp : faChevronDown} 
          className="chevron" 
        />
      </button>
      {isOpen && (
        <div className="block-body">
          <div className="row g-3 align-items-start">
            <div className="col-md-6">
              <div className="form-label">Номер та серія свідоцтва</div>
              <input
                type="text"
                className="form-control"
                value={data.birthCertificateNumber || ''}
                onChange={(e) => handleFieldChange('birthCertificateNumber', e.target.value)}
                placeholder="Введіть номер свідоцтва"
                disabled={isViewOnly || !editable}
              />
            </div>
            <div className="col-md-6">
              <div className="form-label">Дата видачі</div>
              <input
                type="date"
                className="form-control"
                value={data.birthCertificateDate || ''}
                onChange={(e) => handleFieldChange('birthCertificateDate', e.target.value)}
                disabled={isViewOnly || !editable}
              />
            </div>
            <div className="col-md-6">
              <div className="form-label">Країна видачі</div>
              <input
                type="text"
                className="form-control"
                value={data.birthCertificateCountry || ''}
                onChange={(e) => handleFieldChange('birthCertificateCountry', e.target.value)}
                placeholder="Введіть країну видачі"
                disabled={isViewOnly || !editable}
              />
            </div>
          </div>

          {/* Используем FileUploader напрямую */}
          <FileUploader
            label="Завантажте файли"
            description="Файли у форматі PDF, JPG, PNG. Максимальний розмір файлу 2 МБ."
            value={data.birthCertificateFiles || []}
            onChange={handleFilesChange}
            onFileView={handleFileView}
            onFileDownload={onFileDownload}
            editable={editable}
            disabled={isViewOnly || !editable}
            multiple={true}
            maxCount={10}
            asBase64={true}
            onFileViewRequest={onFileViewRequest}
          />
        </div>
      )}
    </div>
  );
};

export default BirthCertificateBlock;